import styled from "styled-components";
import { PopupWrapper } from "../../../style";

export const SolutionTournamentWrapper = styled(PopupWrapper)`
  width: 1016px;
  max-height: 896px;
`;

export const PopupHeader = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 40px 40px 30px;
  box-sizing: border-box;

  > .box {
    display: flex;
    align-items: center;
    gap: 30px;
  }

  .back {
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .button {
    width: 82px;
    height: 28px;
    border-radius: 6.11px;
    background: #d91818;
    color: #fff;
    line-height: 28px;
    text-align: center;
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
  }
`;

export const PopupTap = styled.div`
  padding: 0 40px 10px;
  display: flex;

  > .tap {
    width: 150px;
    text-align: center;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 17px;
    color: #969696;
    padding-bottom: 10px;
    border-bottom: 2px solid #d9d9d9;
    cursor: pointer;

    &.select {
      color: #1a191a;
      border-bottom: 2px solid #121212;
    }
  }

  > .border {
    padding-bottom: 10px;
    width: 320px;
    border-bottom: 2px solid #d9d9d9;
  }
`;

export const MainWrapper = styled.div`
  padding: 0 40px 40px;
  font-family: Pretendard;
  height: calc(100% - 90px);
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  overflow: hidden;

  .no {
    width: 5%;
  }
  .name {
    width: 15%;
  }
  .value {
    width: 12%;
  }
  .total {
    width: 17%;
  }
  .no {
    width: 5%;
  }
`;

export const TournamentTableListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  height: calc(100vh - 200px);
  max-height: 530px;
  overflow-y: auto;
  scrollbar-width: none;
`;

export const TournamentTableListItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 9px 15px;
  box-sizing: border-box;
  border-radius: 13.94px;
  background: #ecf0f3;
`;

export const SolutionTournamentHeader = styled.div`
  width: 100%;
  height: 114px;
  border-radius: 20px;
  display: flex;
`;

export const SolutionTournamentHeaderTotal = styled.div`
  background: #373636;
  width: 225px;
  height: 100%;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 18px;
  color: #fff;
  gap: 4px;

  > .value {
    font-size: 22px;
    > span {
      font-size: 16px;
    }
  }
`;

export const SolutionTournamentHeaderItemWrapper = styled.div`
  background: #ecf0f3;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;

export const SolutionTournamentHeaderItem = styled.div`
  display: flex;
  height: 38px;
  border-bottom: 1px solid #d9d9d9;
  box-sizing: border-box;
  &:nth-child(odd) {
    border-right: 1px solid #d9d9d9;
  }
  &:last-child {
    border-bottom-right-radius: 20px;
  }
  align-items: center;
  color: #121212;
  font-family: Pretendard;

  > .name {
    width: 88px;
    height: 38px;
    background: #d9d9d9;
    font-weight: 500;
    font-size: 14px;
    line-height: 38px;
    text-align: center;
  }

  > .value {
    padding: 0 8px;
    display: flex;
    gap: 4px;
    justify-content: flex-end;
    align-items: flex-end;
    flex: 1;
    font-weight: 600;
    font-size: 18px;

    > span {
      text-align: right;
      width: 37px;
      font-weight: 500;
      font-size: 12px;
    }
  }
`;

export const TournamentTableHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 9px 15px;
  box-sizing: border-box;
  justify-content: space-between;
  border-radius: 10px;
  margin-bottom: 10px;
  margin-top: 19px;

  > .item {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #121212;
    font-family: Pretendard;
    font-size: 11.47px;
    font-weight: 500;
    line-height: 13.68px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const TableDataWrapper = styled.div`
  justify-content: space-between;
  width: 100%;
  display: flex;
  flex-direction: row;

  > .item {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Pretendard;
    font-size: 11.47px;
    font-weight: 500;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 2px;

    > span {
      min-width: 80px;
      max-width: 100%;
      padding: 5px 10px;
      box-sizing: border-box;
      border-radius: 5.73px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  > .name {
    > span {
      background: #373636;
      color: #fff;
    }
  }
  > .total {
    > span {
      background: #d9d9d9;
    }
  }
  > .no {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const TableMoreWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 8px;
  padding: 10px;
  box-sizing: border-box;
  width: 100%;
  max-height: 300px;
  overflow: hidden;
`;

export const MoreDateHeaderWrapper = styled.div`
  display: flex;
  padding: 6px 0;
  width: 100%;

  > .item {
    width: 25%;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 10px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 2px;
  }
`;

export const TournamentTableMoreHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d9d9d9;
  padding-bottom: 6px;
  width: 100%;
  min-height: 20px;

  > .title {
    font-family: Pretendard;
    font-weight: 700;
    font-size: 11px;
  }
`;

export const TournamentTableMoreHeaderItemWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;

  > .info {
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: Pretendard;
    font-weight: 400;
    font-size: 10px;
    white-space: nowrap;

    > .weight {
      font-family: Pretendard;
      font-weight: 700;
      font-size: 11px;
    }
  }
`;

export const MoreDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  scrollbar-width: thin;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #d9d9d9;
    border-radius: 4px;
  }
`;

export const MoreDataItem = styled.div`
  display: flex;
  width: 100%;

  > .item {
    width: 25%;
    font-family: Pretendard;
    font-weight: 400;
    font-size: 10px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 2px;
  }
`;
